export const ids = ['details', 'requirements'] as const;
